import HTTP from './HTTP.js';
import SymfonyErrorFormatter from './SymfonyErrorFormatter';

class PaymentServices {
    static getAvailableCards(agencyId) {
        return HTTP.get(`payments/${agencyId}/get-available-cards`)
            .then((response) => {
                return response.data.data;
            }).catch(() => {
                return Promise.reject('Could not get End Point');
        });
    }
    
    static getAgencyCards(agencyId) {
        return HTTP.get(`payments/${agencyId}/get-agency-cards`)
            .then((response) => {
                return response.data.data;
            }).catch(() => {
                return Promise.reject('Could not get End Point');
        });
    }

    static getClientCards(clientId) {
        return HTTP.get(`payments/${clientId}/get-client-cards`)
            .then((response) => {
                return response.data.data;
            }).catch(() => {
                return Promise.reject('Could not get End Point');
        });
    }

    static addCard(agencyId, card) {
        return HTTP.post(`payments/${agencyId}/save-card`, card)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static addClientCard(clientId, card) {
        return HTTP.post(`payments/${clientId}/save-client-card`, card)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static deleteCard(agencyId, card) {
        return HTTP.post(`payments/${agencyId}/delete-card`, card)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static deleteClientCard(clientId, card) {
        return HTTP.post(`payments/${clientId}/delete-client-card`, card)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static payCampaign(campaignId, card) {
        return HTTP.post(`campaigns/${campaignId}/order`, card)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static updatePermission(agency, permission) {
        return HTTP.post(`agencies/${agency.id}/permissions/${permission.id}`, permission)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static createAgency(agency) {
        agency.status = 'published';
        return HTTP.post(`agencies`, agency)
            .then((response) => {
                // Transformer needs to include address by default;
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

}

export default PaymentServices;
